import script from "./AccountProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountProfile.vue?vue&type=script&setup=true&lang=js"

import "./AccountProfile.vue?vue&type=style&index=0&id=155b5c37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-155b5c37"]])

export default __exports__